import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL;

const login = (data) => {
  return axios.post(`${API_URL}/api/login`, data);
};

const fbLogin = (data) => {
  return axios.post(`${API_URL}/api/facebookLogin`, data);
};

const refreshAuth = (data) => {
  let formData = new FormData();
  formData.append('grant_type', data.grant_type);
  formData.append('refresh_token', data.refresh_token);

  return axios.post(`${API_URL}/oauth/access_token`, formData);
};

const register = (data) => {
  return axios.post(`${API_URL}/api/users`, data);
};

const uploadImage = (image, imageType, resourceId) => {
  const formData = new FormData();
  formData.append('image', image, image.name);
  formData.append('imageType', imageType);
  if (resourceId) {
    formData.append('resourceId', resourceId);
  }

  return axios.post(`${API_URL}/api/files`, formData);
};

const deleteImage = (image) => {
  return axios.delete(`${API_URL}/api/files/${image.id}`);
};

const getCurrentUserDetails = () => {
  return axios.get(`${API_URL}/api/currentUser`);
};

const getUsersAdmin = (params) => {
  if (params && params.userId) {
    return axios.get(`${API_URL}/api/usersAdmin/` + params.userId);
  } else {
    return axios.get(`${API_URL}/api/usersAdmin`, {
      params: params,
    });
  }
};

const editUser = (data) => {
  return axios.put(`${API_URL}/api/users/` + data.user.id, data);
};

const createMarketplace = (data) => {
  return axios.post(`${API_URL}/api/marketplaces`, data);
};

const editMarketplace = (data) => {
  return axios.put(`${API_URL}/api/marketplaces/${data.marketplace.id}`, data);
};

const getMarketplaces = (params) => {
  if (params && params.marketplaceId) {
    return axios.get(`${API_URL}/api/marketplaces/${params.marketplaceId}`);
  } else {
    return axios.get(`${API_URL}/api/marketplaces`, { params });
  }
};

const getDeliveryDayMarketplaces = (params) => {
  if (params?.deliveryDayMarketplaceId) {
    const newParams = Object.assign({}, params);
    delete newParams.deliveryDayMarketplaceId;

    return axios.get(`${API_URL}/api/deliveryDayMarketplaces/${params.deliveryDayMarketplaceId}`, {
      params: newParams,
    });
  } else {
    return axios.get(`${API_URL}/api/deliveryDayMarketplaces`, { params });
  }
};

const editDeliveryDayMarketplace = (data) => {
  return axios.put(`${API_URL}/api/deliveryDayMarketplaces/${data.deliveryDayMarketplace.id}`, data);
};

const createDeliveryDay = (data) => {
  return axios.post(`${API_URL}/api/deliveryDays`, data);
};

const editDeliveryDay = (data) => {
  return axios.put(`${API_URL}/api/deliveryDays/${data.deliveryDay.id}`, data);
};

const deleteDelivery = ({ deliveryId }) => {
  return axios.delete(`${API_URL}/api/deliveries/${deliveryId}`);
};

const getDeliveryDays = (params) => {
  if (params && params.deliveryDayId) {
    return axios.get(`${API_URL}/api/deliveryDays/${params.deliveryDayId}`);
  } else {
    return axios.get(`${API_URL}/api/deliveryDays`, { params });
  }
};

const getCombinedOrderItems = (params) => {
  return axios.get(`${API_URL}/api/combinedOrderItems`, { params });
};

const createCta = (data) => {
  return axios.post(`${API_URL}/api/ctas`, data);
};

const editCta = (data) => {
  return axios.put(`${API_URL}/api/ctas/${data.cta.id}`, data);
};

const getCtas = (params) => {
  if (params && params.ctaId) {
    return axios.get(`${API_URL}/api/ctas/${params.ctaId}`);
  } else {
    return axios.get(`${API_URL}/api/ctas`, { params });
  }
};

const getCtasV2 = (params) => {
  if (params && params.ctaId) {
    return axios.get(`${API_URL}/api/v2/ctas/${params.ctaId}`);
  } else {
    return axios.get(`${API_URL}/api/v2/ctas`, { params });
  }
};

const deleteCta = (id) => {
  return axios.delete(`${API_URL}/api/ctas/${id}`);
};

const createCtaGroup = (data) => {
  return axios.post(`${API_URL}/api/ctaGroups`, data);
};

const editCtaGroup = (data) => {
  return axios.put(`${API_URL}/api/ctaGroups/${data.ctaGroup.id}`, data);
};

const getCtaGroups = (params) => {
  if (params && params.ctaGroupId) {
    return axios.get(`${API_URL}/api/ctaGroups/${params.ctaGroupId}`);
  } else {
    return axios.get(`${API_URL}/api/ctaGroups`, { params });
  }
};

const getCtaGroupsV2 = (params) => {
  if (params && params.ctaGroupId) {
    return axios.get(`${API_URL}/api/v3/ctaGroups/${params.ctaGroupId}`);
  } else {
    return axios.get(`${API_URL}/api/v3/ctaGroups`, { params });
  }
};

const deleteCtaGroups = (id) => {
  return axios.delete(`${API_URL}/api/ctaGroups/${id}`);
};

const getOrders = (params) => {
  if (params && params.orderId) {
    return axios.get(`${API_URL}/api/orders/${params.orderId}`);
  } else {
    return axios.get(`${API_URL}/api/orders`, { params });
  }
};

const getOrderBatches = (params) => {
  if (params && params.orderBatchId) {
    return axios.get(`${API_URL}/api/orderBatches/${params.orderBatchId}`);
  } else {
    return axios.get(`${API_URL}/api/orderBatches/`, { params });
  }
};

const getDeliveryOrderBatches = (params) => {
  if (params && params.deliveryOrderBatchId) {
    return axios.get(`${API_URL}/api/deliveryOrderBatches/${params.deliveryOrderBatchId}`);
  } else {
    return axios.get(`${API_URL}/api/deliveryOrderBatches/`, { params });
  }
};

const createDeliveryOrderBatch = (data) => {
  return axios.post(`${API_URL}/api/deliveryOrderBatches`, data);
};

const editDeliveryOrderBatch = (data) => {
  return axios.put(`${API_URL}/api/deliveryOrderBatches/${data.deliveryOrderBatch.id}`, data);
};

const deleteDeliveryOrderBatch = (params) => {
  return axios.delete(`${API_URL}/api/deliveryOrderBatches`, { params });
};

const deleteOrderBatch = (orderBatchId) => {
  return axios.delete(`${API_URL}/api/orderBatches/${orderBatchId}`);
};

const getItems = (params) => {
  if (params && params.itemId) {
    return axios.get(`${API_URL}/api/v2/items/${params.itemId}`);
  } else {
    return axios.get(`${API_URL}/api/v2/items`, { params });
  }
};

const getMarketplaceItems = (params) => {
  return axios.get(`${API_URL}/api/marketplaceItems`, { params });
};

const editMarketplaceItems = (data) => {
  return axios.put(`${API_URL}/api/marketplaceItems`, data);
};

const createItem = (data) => {
  return axios.post(`${API_URL}/api/items`, data);
};

const editItem = (data) => {
  return axios.put(`${API_URL}/api/items/${data.item.id}`, data);
};

const editItemCategory = (data) => {
  return axios.put(`${API_URL}/api/itemCategories`, data);
};

const editBill = (data) => {
  return axios.put(`${API_URL}/api/bills/${data.bill.id}`, data);
};

const deleteBill = (billId) => {
  return axios.delete(`${API_URL}/api/bills/${billId}`);
};

const getBills = (params) => {
  if (params && params.billId) {
    return axios.get(`${API_URL}/api/bills/${params.billId}`);
  } else {
    return axios.get(`${API_URL}/api/bills`, { params });
  }
};

const getPushNotifications = (params) => {
  if (params && params.pushNotificationId) {
    return axios.get(`${API_URL}/api/pushNotifications/${params.pushNotificationId}`);
  } else {
    return axios.get(`${API_URL}/api/pushNotifications`, { params });
  }
};

const createPushNotification = (data) => {
  return axios.post(`${API_URL}/api/pushNotifications`, data);
};

const editPushNotification = (data) => {
  return axios.put(`${API_URL}/api/pushNotifications/${data.pushNotification.id}`, data);
};

const getEmails = (params) => {
  if (params && params.emailId) {
    return axios.get(`${API_URL}/api/emails/${params.emailId}`);
  } else {
    return axios.get(`${API_URL}/api/emails`, { params });
  }
};

const getPaymentRefunds = (params) => {
  if (params && params.paymentRefundId) {
    return axios.get(`${API_URL}/api/paymentRefunds/${params.paymentRefundId}`, { params });
  } else {
    return axios.get(`${API_URL}/api/paymentRefunds`, { params });
  }
};

const deletePaymentRefund = (paymentRefundId) => {
  return axios.delete(`${API_URL}/api/paymentRefunds/${paymentRefundId}`);
};

const getPayment = (params) => {
  if (params && params.paymentId) {
    return axios.get(`${API_URL}/api/v2/payments/${params.paymentId}`, { params });
  } else {
    return axios.get(`${API_URL}/api/v2/payments`, { params });
  }
};

const editPayment = (data) => {
  return axios.put(`${API_URL}/api/payments/${data.payment.id}`, data);
};

const editOrder = (data) => {
  return axios.put(`${API_URL}/api/orders/${data.order.id}`, data);
};

const editOrderBatch = (data) => {
  return axios.put(`${API_URL}/api/orderBatches/${data.orderBatch.id}`, data);
};

const createPaymentRefund = (data) => {
  return axios.post(`${API_URL}/api/paymentRefunds`, data);
};

const createServiceArea = (data) => {
  return axios.post(`${API_URL}/api/serviceAreas`, data);
};

const editServiceArea = (data) => {
  return axios.put(`${API_URL}/api/serviceAreas/${data.serviceArea.id}`, data);
};

const getAddresses = (params) => {
  if (params && params.addressId) {
    return axios.get(`${API_URL}/api/addresses/${params.addressId}`);
  } else {
    return axios.get(`${API_URL}/api/addresses/`, { params });
  }
};

const createAddress = ({ address, ...rest }) => {
  return axios.post(`${API_URL}/api/addresses`, { address, ...rest });
};

const editAddress = ({ address, ...rest }) => {
  return axios.put(`${API_URL}/api/addresses/${address.id}`, { address, ...rest });
};

const deleteAddress = ({ address }) => {
  return axios.delete(`${API_URL}/api/addresses/${address.id}`);
};

const getServiceAreas = (params) => {
  if (params && params.serviceAreaId) {
    return axios.get(`${API_URL}/api/serviceAreas/${params.serviceAreaId}`);
  } else {
    return axios.get(`${API_URL}/api/serviceAreas`, { params });
  }
};

const editPayoutReport = (data) => {
  return axios.put(`${API_URL}/api/payoutReports/${data.payoutReport.id}`, data);
};

const getPayoutReports = (params) => {
  if (params && params.payoutReportId) {
    return axios.get(`${API_URL}/api/payoutReports/${params.payoutReportId}`);
  } else {
    return axios.get(`${API_URL}/api/payoutReports`, { params });
  }
};

const deletePayoutReport = (payoutReportId) => {
  return axios.delete(`${API_URL}/api/payoutReports/${payoutReportId}`);
};

const createCoupon = (data) => {
  return axios.post(`${API_URL}/api/coupons`, data);
};

const editCoupon = (data) => {
  return axios.put(`${API_URL}/api/coupons/${data.coupon.id}`, data);
};

const getCoupons = (params) => {
  if (params && params.couponId) {
    return axios.get(`${API_URL}/api/coupons/${params.couponId}`);
  } else {
    return axios.get(`${API_URL}/api/coupons`, { params });
  }
};

const deleteCoupon = (couponId) => {
  return axios.delete(`${API_URL}/api/coupons/${couponId}`);
};

const createItemCollection = (data) => {
  return axios.post(`${API_URL}/api/itemCollections`, data);
};

const editItemCollection = (data) => {
  return axios.put(`${API_URL}/api/itemCollections/${data.itemCollection.id}`, data);
};

const getItemCollections = (params) => {
  if (params && params.itemCollectionId) {
    return axios.get(`${API_URL}/api/itemCollections/${params.itemCollectionId}`);
  } else {
    return axios.get(`${API_URL}/api/itemCollections`, { params });
  }
};

const deleteItemCollection = (itemCollectionId) => {
  return axios.delete(`${API_URL}/api/itemCollections/${itemCollectionId}`);
};

const createChef = (data) => {
  return axios.post(`${API_URL}/api/chefs`, data);
};

const editChef = (data) => {
  return axios.put(`${API_URL}/api/chefs/${data.chef.id}`, data);
};

const deleteChef = (chefId) => {
  return axios.delete(`${API_URL}/api/chefs/${chefId}`);
};

const getChefs = (params) => {
  if (params && params.chefId) {
    return axios.get(`${API_URL}/api/chefs/${params.chefId}`);
  } else {
    return axios.get(`${API_URL}/api/chefs`, { params });
  }
};

const createRoutes = ({ deliveryDayTimeRangeId, vehicles, ...other }) => {
  return axios.post(`${API_URL}/api/routes`, {
    deliveryDayTimeRangeId,
    vehicles,
    ...other,
  });
};

const createRoutePlan = ({ routePlan, ...other }) => {
  return axios.post(`${API_URL}/api/routePlans`, {
    routePlan,
    ...other,
  });
};

const createRoutePlanV2 = ({ routePlan, ...other }) => {
  return axios.post(`${API_URL}/api/v2/routePlans`, {
    routePlan,
    ...other,
  });
};

const editRoutePlan = ({ routePlan, ...other }) => {
  return axios.put(`${API_URL}/api/routePlans/${routePlan.id}`, {
    routePlan,
    ...other,
  });
};

const editRoutePlanV2 = ({ routePlan, ...other }) => {
  return axios.put(`${API_URL}/api/v2/routePlans/${routePlan.id}`, {
    routePlan,
    ...other,
  });
};

const deleteRoutePlan = ({ routePlanId }) => {
  return axios.delete(`${API_URL}/api/routePlans/${routePlanId}`);
};

const deleteRoutePlanV2 = ({ routePlanId }) => {
  return axios.delete(`${API_URL}/api/v2/routePlans/${routePlanId}`);
};

const getRoutePlanSetups = (params) => {
  if (params && params.routePlanSetupId) {
    return axios.get(`${API_URL}/api/routePlanSetups/${params.routePlanSetupId}`);
  } else {
    return axios.get(`${API_URL}/api/routePlanSetups`, { params });
  }
};

const editRoutePlanSetup = ({ routePlanSetup, ...other }) => {
  return axios.put(`${API_URL}/api/routePlanSetups/${routePlanSetup.id}`, {
    routePlanSetup,
    ...other,
  });
};

const getRoutes = ({ deliveryDayId, ...other }) => {
  return axios.get(`${API_URL}/api/routes`, {
    params: { deliveryDayId, ...other },
  });
};

const getRoutePlans = ({ deliveryDayTimeRangeId, routePlanId, ...other }) => {
  if (routePlanId) {
    return axios.get(`${API_URL}/api/routePlans/${routePlanId}`, {
      params: {
        deliveryDayTimeRangeId,
        ...other,
      },
    });
  } else {
    return axios.get(`${API_URL}/api/routePlans`, {
      params: { deliveryDayTimeRangeId, ...other },
    });
  }
};

const getRoutePlansV2 = ({ deliveryDayTimeRangeId, routePlanId, ...other }) => {
  if (routePlanId) {
    return axios.get(`${API_URL}/api/v2/routePlans/${routePlanId}`, {
      params: {
        deliveryDayTimeRangeId,
        ...other,
      },
    });
  } else {
    return axios.get(`${API_URL}/api/v2/routePlans`, {
      params: { deliveryDayTimeRangeId, ...other },
    });
  }
};

const getRoutePlan = ({ routePlanId }) => {
  return axios.get(`${API_URL}/api/routePlans/${routePlanId}`);
};

const createRouteOptimisationResult = (data) => {
  return axios.post(`${API_URL}/api/routeOptimisationResults`, data);
};

const editRouteOptimisationResult = (data) => {
  return axios.put(`${API_URL}/api/routeOptimisationResults/${data.routeOptimisationResult.id}`, data);
};

const createVehicle = (data) => {
  return axios.post(`${API_URL}/api/routePlanVehicles`, data);
};

const editVehicle = (data) => {
  return axios.put(`${API_URL}/api/routePlanVehicles/${data.vehicle.id}`, data);
};

const getDrivers = ({ ...other }) => {
  return axios.get(`${API_URL}/api/drivers`, {
    params: { ...other },
  });
};

const getDriversV2 = ({ ...other }) => {
  return axios.get(`${API_URL}/api/v2/drivers`, {
    params: { ...other },
  });
};

const createDriver = (data) => {
  return axios.post(`${API_URL}/api/drivers`, data);
};

const createDriverV2 = (data) => {
  return axios.post(`${API_URL}/api/v2/drivers`, data);
};

const editDriver = (data) => {
  return axios.put(`${API_URL}/api/drivers/${data.driver.id}`, data);
};

const editDriverV2 = (data) => {
  return axios.put(`${API_URL}/api/v2/drivers/${data.driver.id}`, data);
};

const deleteDriver = ({ driverId }) => {
  return axios.delete(`${API_URL}/api/drivers/${driverId}`);
};

const editRoute = (data) => {
  return axios.put(`${API_URL}/api/routes/${data.route.id}`, data);
};

const deleteRoute = ({ routeId }) => {
  return axios.delete(`${API_URL}/api/routes/${routeId}`);
};

const createDelivery = (data) => {
  return axios.post(`${API_URL}/api/deliveries`, data);
};

const createDeliveryV2 = (data) => {
  return axios.post(`${API_URL}/api/v2/deliveries`, data);
};

const getDeliveries = (params) => {
  if (params && params.deliveryId) {
    return axios.get(`${API_URL}/api/deliveries/${params.deliveryId}`);
  } else {
    return axios.get(`${API_URL}/api/deliveries`, { params });
  }
};

const editDelivery = (data) => {
  return axios.put(`${API_URL}/api/deliveries/${data.delivery.id}`, data);
};

const createSms = (data) => {
  return axios.post(`${API_URL}/api/smses`, data);
};

const createRecipe = (data) => {
  return axios.post(`${API_URL}/api/recipes`, data);
};

const editRecipe = (data) => {
  return axios.put(`${API_URL}/api/recipes/${data.recipe.id}`, data);
};

const deleteRecipe = (recipeId) => {
  return axios.delete(`${API_URL}/api/recipes/${recipeId}`);
};

const getRecipes = (params) => {
  if (params && params.recipeId) {
    return axios.get(`${API_URL}/api/recipes/${params.recipeId}`);
  } else {
    return axios.get(`${API_URL}/api/recipes`, { params });
  }
};

const createFeature = (data) => {
  return axios.post(`${API_URL}/api/features`, data);
};

const editFeature = (data) => {
  return axios.put(`${API_URL}/api/features/${data.feature.id}`, data);
};

const deleteFeature = (featureId) => {
  return axios.delete(`${API_URL}/api/features/${featureId}`);
};

const getFeatures = (params) => {
  if (params && params.featureId) {
    return axios.get(`${API_URL}/api/features/${params.featureId}`);
  } else {
    return axios.get(`${API_URL}/api/features`, { params });
  }
};

const createStartDepot = (data) => {
  return axios.post(`${API_URL}/api/startDepots`, data);
};

const getStartDepots = (params) => {
  if (params && params.startDepotId) {
    return axios.get(`${API_URL}/api/startDepots/${params.startDepotId}`);
  } else {
    return axios.get(`${API_URL}/api/startDepots`, { params });
  }
};

const editStartDepot = (data) => {
  return axios.put(`${API_URL}/api/startDepots/${data.startDepot.id}`, data);
};

const deleteStartDepot = ({ startDepotId }) => {
  return axios.delete(`${API_URL}/api/startDepots/${startDepotId}`);
};

const createUserLink = (data) => {
  return axios.post(`${API_URL}/api/userLinks`, data);
};

const getPaymentMethods = (params) => {
  if (params && params.paymentMethodId) {
    return axios.get(`${API_URL}/api/paymentMethods/${params.paymentMethodId}`);
  } else {
    return axios.get(`${API_URL}/api/paymentMethods`, { params });
  }
};

const getSubscriptions = (params) => {
  if (params && params.subscriptionId) {
    return axios.get(`${API_URL}/api/subscriptions/${params.subscriptionId}`);
  } else {
    return axios.get(`${API_URL}/api/subscriptions`, { params });
  }
};

const editSubscription = ({ subscription }) => {
  return axios.put(`${API_URL}/api/subscriptions/${subscription.id}`, { subscription });
};

const createPaymentMethod = ({ paymentMethod }) => {
  return axios.post(`${API_URL}/api/paymentMethods`, { paymentMethod });
};

const editPaymentMethod = ({ paymentMethod }) => {
  return axios.put(`${API_URL}/api/paymentMethods/${paymentMethod.id}`, { paymentMethod });
};

const getBusinessProfiles = (params) => {
  if (params && params.businessProfileId) {
    return axios.get(`${API_URL}/api/businessProfiles/${params.businessProfileId}`);
  } else {
    return axios.get(`${API_URL}/api/businessProfiles`, { params });
  }
};

const editBusinessProfile = ({ businessProfile }) => {
  return axios.put(`${API_URL}/api/businessProfiles/${businessProfile.id}`, { businessProfile });
};

const getItemFirstLevelCategories = (params) => {
  return axios.get(`${API_URL}/api/itemCategories`, { params });
};

const apiCalls = {
  login,
  refreshAuth,
  fbLogin,
  register,
  uploadImage,
  deleteImage,
  getCurrentUserDetails,
  editUser,
  getUsersAdmin,
  createMarketplace,
  editMarketplace,
  getMarketplaces,
  getDeliveryDays,
  createDeliveryDay,
  editDeliveryDay,
  getDeliveryDayMarketplaces,
  editDeliveryDayMarketplace,
  getCombinedOrderItems,
  createCta,
  editCta,
  getCtas,
  getCtasV2,
  deleteCta,
  createCtaGroup,
  editCtaGroup,
  getCtaGroups,
  getCtaGroupsV2,
  deleteCtaGroups,
  getOrders,
  getOrderBatches,
  getDeliveryOrderBatches,
  createDeliveryOrderBatch,
  editDeliveryOrderBatch,
  deleteDeliveryOrderBatch,
  deleteOrderBatch,
  getMarketplaceItems,
  editMarketplaceItems,
  getItems,
  createItem,
  editItem,
  editItemCategory,
  editBill,
  deleteBill,
  getBills,
  getPushNotifications,
  createPushNotification,
  editPushNotification,
  getEmails,
  getPaymentRefunds,
  deletePaymentRefund,
  getPayment,
  editPayment,
  createPaymentRefund,
  getServiceAreas,
  createServiceArea,
  editServiceArea,
  getAddresses,
  createAddress,
  editAddress,
  deleteAddress,
  editPayoutReport,
  getPayoutReports,
  deletePayoutReport,
  createCoupon,
  editCoupon,
  getCoupons,
  deleteCoupon,
  createItemCollection,
  editItemCollection,
  getItemCollections,
  deleteItemCollection,
  editOrder,
  editOrderBatch,
  createChef,
  editChef,
  deleteChef,
  getChefs,
  createRecipe,
  editRecipe,
  deleteRecipe,
  getRecipes,
  createFeature,
  editFeature,
  deleteFeature,
  getFeatures,
  createRoutes,
  getDrivers,
  getDriversV2,
  deleteDriver,
  createDriver,
  createDriverV2,
  editDriver,
  editDriverV2,
  getRoutes,
  getRoutePlans,
  getRoutePlansV2,
  createRoutePlan,
  createRoutePlanV2,
  editRoutePlan,
  editRoutePlanV2,
  deleteRoutePlan,
  deleteRoutePlanV2,
  getRoutePlanSetups,
  editRoutePlanSetup,
  createRouteOptimisationResult,
  editRouteOptimisationResult,
  editVehicle,
  editRoute,
  deleteRoute,
  createSms,
  createDelivery,
  createDeliveryV2,
  getDeliveries,
  editDelivery,
  deleteDelivery,
  createVehicle,
  getStartDepots,
  editStartDepot,
  deleteStartDepot,
  createStartDepot,
  createUserLink,
  createPaymentMethod,
  editPaymentMethod,
  getPaymentMethods,
  getSubscriptions,
  editSubscription,
  getBusinessProfiles,
  editBusinessProfile,
  getItemFirstLevelCategories,
};

export default apiCalls;
